/**
 * 報告不要業者データ補完
 * 報告不要業者モーダル
 */
import Vue from "vue";
import * as httpConst from "@/constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/none_report_traders`

const getDefaultState = () => {
  return {}
}

const transferNoneReportTrader = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 報告不要業者一覧
     */
    index ({commit}, {params}) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 報告不要業者 初期情報取得
     * @param id {Number} JWNETマニフェスト_ID
     * @param params { Object }
     */
    show ({ commit }, { id, params } ) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params}).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 報告不要業者 新規登録
     * @param jwnet_manifest_id {Number} JWNETマニフェスト_ID
     * @param params {Object} 報告不要業者情報
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 報告不要業者 更新
     * 一覧選択からの登録(更新)で使用
     * @param params {Object}
     * @param params.none_report_trader_id {Number} 報告不要業者_ID
     * @param params.none_report_trader_location_code {String} 報告不要事業場コード
     * @param params.target_section {Number} 区間
     * @param params.target_type {String} 業者種別 transporter,trader,disposer 
     * @param params.jwnet_manifest_ids {Array} 反映する
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.patch(`${API_PATH}/${id}`, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  }
}

export default transferNoneReportTrader;
